import React, { useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import {
  AppBar,
  Box,
  Toolbar,
  Typography,
  Button,
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemText,
  ListItemButton,
  Container,
  Switch,
  FormControlLabel,
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import CalculateIcon from '@mui/icons-material/Calculate';
import Brightness4Icon from '@mui/icons-material/Brightness4';
import AccessibilityNewIcon from '@mui/icons-material/AccessibilityNew';

const pages = [
  { title: 'Financial', path: '/financial' },
  { title: 'Math', path: '/math' },
  { title: 'Fitness', path: '/fitness' },
  { title: 'Other', path: '/other' },
  { title: 'About', path: '/about' },
  { title: 'Contact', path: '/contact' },
];

const Header = () => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [highContrast, setHighContrast] = useState(false);
  const [largeButtons, setLargeButtons] = useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const handleHighContrastChange = (event) => {
    setHighContrast(event.target.checked);
    if (event.target.checked) {
      document.body.classList.add('high-contrast');
    } else {
      document.body.classList.remove('high-contrast');
    }
  };

  const handleLargeButtonsChange = (event) => {
    setLargeButtons(event.target.checked);
    if (event.target.checked) {
      document.body.classList.add('large-buttons');
    } else {
      document.body.classList.remove('large-buttons');
    }
  };

  const drawer = (
    <Box onClick={handleDrawerToggle} sx={{ textAlign: 'center' }}>
      <Typography variant="h6" sx={{ my: 2, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <CalculateIcon sx={{ mr: 1 }} />
        Solverwatch
      </Typography>
      <List>
        {pages.map((page) => (
          <ListItem key={page.title} disablePadding>
            <ListItemButton
              component={RouterLink}
              to={page.path}
              sx={{ textAlign: 'center' }}
            >
              <ListItemText primary={page.title} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
      <Box sx={{ mt: 2, px: 2 }}>
        <FormControlLabel
          control={<Switch checked={highContrast} onChange={handleHighContrastChange} />}
          label="High Contrast"
        />
        <FormControlLabel
          control={<Switch checked={largeButtons} onChange={handleLargeButtonsChange} />}
          label="Large Buttons"
        />
      </Box>
    </Box>
  );

  return (
    <AppBar position="static" component="header" role="banner">
      <Container maxWidth="xl">
        <Toolbar disableGutters>
          {/* Mobile menu icon */}
          <Box sx={{ flexGrow: 0, display: { xs: 'flex', md: 'none' } }}>
            <IconButton
              size="large"
              aria-label="open navigation menu"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleDrawerToggle}
              color="inherit"
            >
              <MenuIcon />
            </IconButton>
          </Box>

          {/* Logo */}
          <Typography
            variant="h6"
            noWrap
            component={RouterLink}
            to="/"
            sx={{
              mr: 2,
              display: 'flex',
              alignItems: 'center',
              fontWeight: 700,
              color: 'inherit',
              textDecoration: 'none',
            }}
          >
            <CalculateIcon sx={{ mr: 1 }} />
            Solverwatch
          </Typography>

          {/* Desktop navigation */}
          <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' } }}>
            {pages.map((page) => (
              <Button
                key={page.title}
                component={RouterLink}
                to={page.path}
                sx={{ my: 2, color: 'white', display: 'block' }}
              >
                {page.title}
              </Button>
            ))}
          </Box>

          {/* Accessibility controls */}
          <Box sx={{ display: { xs: 'none', md: 'flex' }, alignItems: 'center' }}>
            <IconButton color="inherit" aria-label="toggle high contrast mode" onClick={handleHighContrastChange}>
              <Brightness4Icon />
            </IconButton>
            <IconButton color="inherit" aria-label="toggle large buttons mode" onClick={handleLargeButtonsChange}>
              <AccessibilityNewIcon />
            </IconButton>
          </Box>
        </Toolbar>
      </Container>

      {/* Mobile drawer */}
      <Drawer
        variant="temporary"
        open={mobileOpen}
        onClose={handleDrawerToggle}
        ModalProps={{ keepMounted: true }}
        sx={{
          display: { xs: 'block', md: 'none' },
          '& .MuiDrawer-paper': { boxSizing: 'border-box', width: 240 },
        }}
      >
        {drawer}
      </Drawer>
    </AppBar>
  );
};

export default Header;
